import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Components/Login'
import Dashboard from './Components/Dashboard';
import AllCards from './Components/AllCards';
import GamePage from './Components/GamePage';
import Report from './Components/Reports';
import AdminTable from './Components/AllStats';
import Keriti from './Components/Keriti';
import BingoCards from './Components/BingoCards/BingoCards';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/all-cards" element={<AllCards />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/game-in-progress" element={<GamePage />} />
        <Route path="/reports" element={<Report />} />
        <Route path="/pyt/axs" element={<AdminTable />} />
        <Route path="/shashemene" element={<Keriti />} />
        <Route path="/bingo-cards" element={<BingoCards />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
